// theirs
import styled from 'styled-components'
// ours
import { IntroStatementProps } from '.'
import { respondToRetina, respondToWidth } from '../../../mixins/respondTo'
import { color, typography } from '../../../styles'

export const introStatementBaseClass = 'intro-statement'

export const StyledIntroStatement = styled.div<IntroStatementProps>`
    &.${introStatementBaseClass} {
        background-color: ${(props) => props.content.contentBackgroundColor};
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: table;
        z-index: 2;

        .title-wrapper {
            display: table-cell;
            vertical-align: middle;
            text-align: center;
            position: relative;
            z-index: 30;
        }

        h2 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};
            font-size: ${typography.size.l4};
            color: ${color.deepcarminepink};
            text-transform: uppercase;
            max-width: auto;
            text-align: center;
            margin: -4rem auto 0 auto;
            padding: 0 1rem;
            letter-spacing: normal;
            line-height: normal;

            ${respondToWidth.xs`
                font-size: ${typography.size.l6};
            `}

            ${respondToWidth.md`
                font-size: ${typography.size.code};
            `}

            ${respondToWidth.lg`
                margin: -7rem auto 0 auto;
            `}

            ${respondToWidth.xl`
                font-size: ${typography.size.code1};
            `}

            ${respondToWidth.xxl`
                font-size: ${typography.size.code2};
            `}

            ${respondToRetina.xxxxl`
                font-size: ${typography.size.code3};
            `}
        }

        .image-wrapper {
            width: 100%;
            text-align: center;
            display: block;
            position: absolute;
            bottom: 0;
            z-index: 20;
            left: 0;
            height: 100%;
            overflow: hidden;
            div {
                width: 100%;
                height: 100%;
                 
                text-align: center;
                display: block;
                position: absolute;
                bottom: 0;
                animation: animateUluruRock 2s ease-out;
            }
        }

        @keyframes animateUluruRock {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }

        picture img {
            position: absolute;
            bottom: -4px;
            right: -700px;

            ${respondToWidth.md`
            right: -500px;
        `}

            ${respondToWidth.lg`
            right: -960px;
        `}

        ${respondToWidth.xl`
            right: -850px;
        `}

        ${respondToWidth.xxl`
            right: -950px;
        `}

        ${respondToWidth.xxxl`
            right: -250px;
        `}

        ${respondToWidth.xxxxl`
            right: 0;
        `}
        }

        .help-text-wrapper {
            width: 100%;
            text-align: center;
            display: block;
            position: absolute;
            bottom: 0;
            z-index: 30;
            left: 0;

            .help-text {
                background-color: ${color.raisinblack};

                color: ${color.lightest};
                width: max-content;
                margin: 0 auto 1rem auto;
                padding: 0.15rem 0.5rem;

                font-size: ${typography.size.m1};
                ${respondToWidth.xs`
                font-size: ${typography.size.m2};
            `}

                ${respondToWidth.md`
                font-size: ${typography.size.m1};
            `}
            }

            .vertical-line {
                border-left: 2px solid ${color.lightest};
                height: 2rem;
                margin: 0 auto;
                width: 2px;

                ${respondToWidth.lg`
                height: 8.5rem;
            `}

                ${respondToWidth.xl`
                height: 9rem;
            `}

            ${respondToWidth.xxl`
                height: 10.5rem;
            `}
            }
        }
    }
`
